// Product Gallery Swiper - Simplified
document.addEventListener('DOMContentLoaded', function () {
  // Get product info
  const productData = document.querySelector('[data-product-info]');
  if (productData) {
    try {
      window.product = JSON.parse(productData.getAttribute('data-product-info'));
    } catch (error) {
      // Error parsing product data
    }
  }

  // Check if Swiper is available
  if (typeof Swiper === 'undefined') {
    return;
  }

  // Get elements
  const thumbsElement = document.querySelector('.thumbs-swiper');
  const mainElement = document.querySelector('.main-swiper');

  if (!thumbsElement || !mainElement) return;

  // Prevent duplicate initialization
  if (thumbsElement.swiper || mainElement.swiper) return;

  // Initialize thumbs swiper
  const thumbsSwiper = new Swiper('.thumbs-swiper', {
    spaceBetween: 5,
    slidesPerView: 'auto',
    direction: 'vertical',
    watchSlidesProgress: true,
    watchSlidesVisibility: true
  });

  // Initialize main swiper
  const mainSwiper = new Swiper('.main-swiper', {
    slidesPerView: 1.1,
    spaceBetween: 5,
    thumbs: { swiper: thumbsSwiper },
    navigation: {
      nextEl: '.main-swiper .swiper-button-next',
      prevEl: '.main-swiper .swiper-button-prev',
    },
    pagination: {
      el: '.main-swiper .swiper-pagination',
      clickable: true,
    },
    zoom: {
      maxRatio: 2,
      zoomedSlideClass: '-zoomed',
    },
    watchSlidesProgress: true,
    breakpoints: {
      767: {
        slidesPerView: 1,
      },
      992: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
    on: {
      init: function () {
        // Set first thumb as active
        const firstThumb = document.querySelector('.thumbs-swiper .swiper-slide');
        if (firstThumb) firstThumb.classList.add('swiper-slide-thumb-active');
      },
      slideChange: function () {
        // Update active thumb
        document.querySelectorAll('.thumbs-swiper .swiper-slide').forEach((slide, index) => {
          slide.classList.toggle('swiper-slide-thumb-active', index === this.activeIndex);
        });
      },
      zoomChange: function (swiper, scale) {
        // Disable touch/swipe when zoomed
        if (scale > 1) {
          swiper.allowTouchMove = false;
        } else {
          swiper.allowTouchMove = true;
        }
      }
    }
  });

  // Thumb click navigation
  document.querySelectorAll('.thumbs-swiper .swiper-slide').forEach((slide, index) => {
    slide.addEventListener('click', () => mainSwiper.slideTo(index));
  });


  // Desktop zoom functionality
  if (window.innerWidth > 991) {
    mainSwiper.slides.forEach(slide => {
      let lastMoveTime = 0;

      slide.addEventListener('mousemove', (event) => {
        if (!slide.classList.contains('-zoomed')) return;

        // Throttle to 60fps for smooth performance
        const now = Date.now();
        if (now - lastMoveTime < 16) return;
        lastMoveTime = now;

        const zoomContainer = slide.querySelector('.swiper-zoom-container');
        const zoomedImage = slide.querySelector('.swiper-zoom-target');
        if (!zoomContainer || !zoomedImage) return;

        const rect = slide.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;

        // Calculate percentage position (0 to 1)
        const percentX = mouseX / rect.width;
        const percentY = mouseY / rect.height;

        // Get image dimensions
        const imageRect = zoomedImage.getBoundingClientRect();
        const containerRect = zoomContainer.getBoundingClientRect();

        // Calculate how much the image can move
        const maxMoveX = (imageRect.width - containerRect.width) / 2;
        const maxMoveY = (imageRect.height - containerRect.height) / 2;

        // Calculate movement based on mouse position
        const moveX = (percentX - 0.5) * maxMoveX * 2;
        const moveY = (percentY - 0.5) * maxMoveY * 2;

        // Apply smooth movement
        zoomContainer.style.transform = `translate3d(${-moveX}px, ${-moveY}px, 0px)`;
      });
    });
  }

  // Mobile zoom on click
  if (window.innerWidth <= 991) {
    mainSwiper.slides.forEach(slide => {
      slide.addEventListener('click', (event) => {
        const isZoomed = slide.classList.contains('-zoomed');
        const isImageClick = event.target.tagName === 'IMG' || event.target.closest('img');

        if (isImageClick) {
          // Only prevent default and stop propagation for image clicks
          event.preventDefault();
          event.stopPropagation();

          if (isZoomed) {
            mainSwiper.zoom.out();
          } else {
            mainSwiper.zoom.in(null, slide);
          }
        } else if (isZoomed) {
          // If clicking outside image but slide is zoomed, zoom out
          event.preventDefault();
          event.stopPropagation();
          mainSwiper.zoom.out();
        }
        // If not clicking on image and not zoomed, let normal behavior happen (scroll, etc.)
      });

      // Prevent scroll only when zoomed and touching the image
      slide.addEventListener('touchmove', (event) => {
        if (slide.classList.contains('-zoomed')) {
          const isImageTouch = event.target.tagName === 'IMG' || event.target.closest('img');
          if (isImageTouch) {
            event.preventDefault();
          }
        }
      }, { passive: false });
    });
  }
});

// Product buy button, conjunto, and add-to-cart — independent of Swiper gallery
document.addEventListener('DOMContentLoaded', function () {
  if (!window.product) {
    const productData = document.querySelector('[data-product-info]');
    if (productData) {
      try {
        window.product = JSON.parse(productData.getAttribute('data-product-info'));
      } catch (error) {
        // Error parsing product data
      }
    }
  }

  const productOptions = document.querySelectorAll('.product-options input[type="radio"]');
  const buyButton = document.querySelector('.buy-button');
  const variantIdInput = document.getElementById('variant-id');
  const quantityInput = document.querySelector('.quantity-input');
  const minusButton = document.querySelector('.quantity-button.minus');
  const plusButton = document.querySelector('.quantity-button.plus');
  const notifyMeSection = document.getElementById('notify-me');
  const buyWrapper = document.querySelector('.buy-wrapper');

  // Function to show/hide button icons based on product availability
  function updateButtonIcons(show) {
    // Seleciona o ícone dentro do botão principal de compra
    const buyButton = document.querySelector('.buy-button');
    if (!buyButton) return;
    const icon = buyButton.querySelector('svg, .icon-buy');
    if (icon) {
      icon.style.display = show ? 'inline-block' : 'none';
    }

    // Sticky bar (desktop)
    const stickyButton = document.querySelector('.sticky-buy-bar__add-btn');
    if (stickyButton) {
      const stickyIcon = stickyButton.querySelector('svg, .icon-buy');
      if (stickyIcon) {
        stickyIcon.style.display = show ? 'inline-block' : 'none';
      }
    }

    // Sticky bar (mobile)
    const stickyMobileButton = document.querySelector('.sticky-buy-bar__mobile-btn');
    if (stickyMobileButton) {
      const stickyMobileIcon = stickyMobileButton.querySelector('svg, .icon-buy');
      if (stickyMobileIcon) {
        stickyMobileIcon.style.display = show ? 'inline-block' : 'none';
      }
    }
  }

  // Make updateBuyButtonState global so it can be accessed by sticky bar sync
  window.updateBuyButtonState = function updateBuyButtonState() {
    if (!window.product || !window.product.variants) {
      return;
    }

    const buyButton = document.querySelector('.buy-button');
    if (!buyButton) return;

    // --- 0. CONJUNTO LOGIC (Precedence over everything) ---
    const conjuntoContainer = document.querySelector('[data-product-conjunto]');
    if (conjuntoContainer) {
      const allBoxes = conjuntoContainer.querySelectorAll('.conjunto-product-checkbox-input');
      const disabledBoxes = conjuntoContainer.querySelectorAll('.conjunto-product-checkbox-input:disabled');

      // If every item is completely out of stock, force Indisponível
      if (allBoxes.length > 0 && disabledBoxes.length === allBoxes.length) {
         buyButton.disabled = true;
         const btnText = buyButton.querySelector('.button-text');
         if (btnText) btnText.textContent = 'Indisponível';
         updateButtonIcons(false);
         const productCounter = document.querySelector('.product-counter');
         if (productCounter) productCounter.style.display = 'none';
         return;
      }

      let validConjunto = true;
      const checkedSubProducts = conjuntoContainer.querySelectorAll('.conjunto-product-checkbox-input:checked');

      // Ensure at least one checked if checkboxes exist
      if (allBoxes.length > 0 && checkedSubProducts.length === 0) {
         validConjunto = false;
      }
      
      checkedSubProducts.forEach(input => {
        const productItem = input.closest('.conjunto-product-item');
        const hasVariants = productItem && productItem.querySelectorAll('.conjunto-option-value').length > 0;
        const variantSelected = input.dataset.variantId && input.dataset.variantId !== '';
        
        // Only require variant selection if options exist
        if (hasVariants && !variantSelected) {
          validConjunto = false;
        }
      });

      if (validConjunto) {
         buyButton.disabled = false;
         const btnText = buyButton.querySelector('.button-text');
         if (btnText) btnText.textContent = 'Adicionar ao carrinho';
         updateButtonIcons(true);
         if (typeof notifyMeSection !== 'undefined' && notifyMeSection) notifyMeSection.classList.remove('active');
         
         const productCounter = document.querySelector('.product-counter');

         if (productCounter) productCounter.style.display = 'block';

      } else {
         buyButton.disabled = true;
         const btnText = buyButton.querySelector('.button-text'); 
         if (btnText) btnText.textContent = 'Selecione as opções do conjunto';
         updateButtonIcons(false);
         
         const productCounter = document.querySelector('.product-counter');

         if (productCounter) productCounter.style.display = 'none';

      }
      return; 
    }

    // --- 1. Basic Availability Check ---
    if (!window.product.available) {
      if (buyButton) {
        buyButton.disabled = true;
        const btnText = buyButton.querySelector('.button-text');
        if (btnText) btnText.textContent = 'Indisponível';
      }
      notifyMeSection?.classList.add('active');
      updateButtonIcons(false);
      return;
    }

    const allVariantsUnavailable = window.product.variants.every(v => !v.available);
    if (allVariantsUnavailable) {
      notifyMeSection?.classList.add('active');
      updateButtonIcons(false);

      return;
    }

    // --- 2. Option Selection Check ---
    const selectedOptions = {};
    let allOptionsSelected = true;
    const optionGroups = {};

    productOptions.forEach(option => {
      const optionName = option.getAttribute('data-option-name');
      if (!optionGroups[optionName]) optionGroups[optionName] = [];
      optionGroups[optionName].push(option);
    });

    for (const [optionName, options] of Object.entries(optionGroups)) {
      const selectedOption = options.find(option => option.checked);
      if (selectedOption) {
        selectedOptions[optionName] = selectedOption.value;
      } else {
        allOptionsSelected = false;
      }
    }

    // Simple products or products with only one variant
    if (productOptions.length === 0 || window.product.variants.length === 1) {
      allOptionsSelected = true;
    }

    // --- 3. Determine Initial State ---
    let isAvailable = false;
    let buttonLabel = 'Selecione as opções';
    let disableButton = true;
    let selectedVariant = null;

    if (!allOptionsSelected) {
      buttonLabel = 'Selecione o tamanho';
      updateButtonIcons(true);
      notifyMeSection?.classList.remove('active');
    } else {
      // Find variant
      if (Object.keys(selectedOptions).length > 0) {
        selectedVariant = window.product.variants.find(variant => {
          return Object.keys(selectedOptions).every(optionName => {
            const optionIndex = window.product.options.indexOf(optionName);
            return variant.options[optionIndex] === selectedOptions[optionName];
          });
        });
      } else if (productOptions.length === 0) {
        selectedVariant = window.product.variants.find(variant => variant.available) || window.product.variants[0];
      }

      if (selectedVariant) {
        isAvailable = selectedVariant.available;
        // Important: For Conjunto, we might ignore the main variant's stock if it's just a holder
        // But for now let's stick to standard behavior unless it's a Conjunto container logic override.
        // Actually, for Conjunto, the 'Available' state usually depends on the sub-products, 
        // but the main product must also be 'available' in Shopify's eyes to be purchaseable typically.
        // However, if the main product is out of stock but 'continue selling' is on, it is available.

        if (isAvailable) {
          buttonLabel = 'Adicionar ao carrinho';
          disableButton = false;
          if (variantIdInput) variantIdInput.value = selectedVariant.id;
        } else {
          buttonLabel = 'Indisponível';
          disableButton = true;
        }
      } else {
        buttonLabel = 'Indisponível'; // Variant doesn't exist combination
      }
    }

    // --- 4. Conjunto Validation (The Critical Part) ---
    // REMOVED: Handled at step 0 for precedence

    // --- 5. Apply State to UI ---
    if (buyButton) {
      buyButton.disabled = disableButton;
      const btnText = buyButton.querySelector('.button-text');
      if (btnText) btnText.textContent = buttonLabel;
    }

    // Notify Me
    if (selectedVariant && !selectedVariant.available) {
      console.log('iStock Debug: Showing Notify Me for variant', selectedVariant.id);
      notifyMeSection?.classList.add('active');
      notifyMeSection?.setAttribute('data-variant-id', selectedVariant.id);
    } else {
      if (notifyMeSection?.classList.contains('active')) {
        console.log('iStock Debug: Hiding Notify Me (Product Available or No Variant)');
      }
      notifyMeSection?.classList.remove('active');
    }

    // Visibility toggles
    const productCounter = document.querySelector('.product-counter');


    // We show these only if available (and valid conjunto if applicable)
    const showExtras = !disableButton; // Simplified logic: if button is enabled, show extras

    if (productCounter) productCounter.style.display = showExtras ? 'block' : 'none';


    updateButtonIcons(!disableButton);
  }; // End of updateBuyButtonState function
  productOptions.forEach(option => {
    option.addEventListener('change', () => {
      updateBuyButtonState();

      // Force sync to sticky bar after main option change
      setTimeout(() => {
        const mainVariantSelect = document.getElementById('variant-id');
        if (mainVariantSelect && mainVariantSelect.value) {
          const stickySelects = document.querySelectorAll('.sticky-buy-bar__select-variant');
          stickySelects.forEach(stickySelect => {
            if (stickySelect.name === 'id') {
              stickySelect.value = mainVariantSelect.value;
              stickySelect.style.color = '#222';
            }
          });
        }
      }, 100);
    });
  });

  // Auto-select single option if only one is available
  function autoSelectSingleOptions() {
    const optionGroups = {};

    // Group options by their option name
    productOptions.forEach(option => {
      const optionName = option.getAttribute('data-option-name');
      if (!optionGroups[optionName]) {
        optionGroups[optionName] = [];
      }
      optionGroups[optionName].push(option);
    });

    // Check each option group for auto-selection logic
    Object.entries(optionGroups).forEach(([optionName, options]) => {
      const availableOptions = options.filter(option => {
        // Check if this option value is available in any variant
        const isAvailableInVariant = window.product.variants.some(variant => {
          const optionIndex = window.product.options.indexOf(optionName);
          return variant.options[optionIndex] === option.value && variant.available;
        });

        // Also check if the option element doesn't have 'unavailable' class
        const optionElement = option.closest('.facet-checkbox');
        const isNotUnavailable = !optionElement || !optionElement.querySelector('.unavailable');

        return isAvailableInVariant && isNotUnavailable;
      });

      // Auto-selection logic:
      // 1. If only one option total, select it regardless of availability
      // 2. If multiple options but only one available, select the available one
      // 3. If multiple options but all unavailable, select the first one
      if (options.length === 1) {
        // Only one option total - select it
        options[0].checked = true;
      } else if (availableOptions.length === 1) {
        // Multiple options but only one available - select the available one
        availableOptions[0].checked = true;
      }
      // Removed the auto-select of first option if multiple/none available
    });

    // Update button state after auto-selection
    updateBuyButtonState();
  }

  // Initial check
  updateBuyButtonState();

  // Auto-select single options after initial check
  autoSelectSingleOptions();

  minusButton?.addEventListener('click', () => {
    const currentValue = parseInt(quantityInput.value);
    if (currentValue > 1) {
      quantityInput.value = currentValue - 1;
    }
  });

  plusButton?.addEventListener('click', () => {
    const currentValue = parseInt(quantityInput.value);
    quantityInput.value = currentValue + 1;
  });

  quantityInput?.addEventListener('change', () => {
    if (quantityInput.value < 1) {
      quantityInput.value = 1;
    }
  });
  // Product Conjunto functionality
  // Function to calculate and update total prices including conjunto products
  function updateTotalPrices() {
    const priceContainers = document.querySelectorAll('[data-product-prices]');
    if (!priceContainers.length) return;

    const conjuntoSection = document.querySelector('[data-product-conjunto]');
    let conjuntoTotalPrice = 0;
    let conjuntoTotalComparePrice = 0;

    if (conjuntoSection) {
      const checkedBoxes = conjuntoSection.querySelectorAll('.conjunto-product-checkbox-input:checked');
      checkedBoxes.forEach(checkbox => {
        const productItem = checkbox.closest('.conjunto-product-item');
        if (productItem) {
          // Get the selected option button to get variant price, or use checkbox data
          const selectedOption = productItem.querySelector('.conjunto-option-value.selected');
          const priceContainer = productItem.querySelector('[data-conjunto-price]');

          let variantPrice = 0;
          let variantComparePrice = 0;

          if (selectedOption && selectedOption.dataset.variantPrice) {
            variantPrice = parseInt(selectedOption.dataset.variantPrice);
            variantComparePrice = selectedOption.dataset.variantComparePrice ? parseInt(selectedOption.dataset.variantComparePrice) : variantPrice;
          } else if (priceContainer) {
            // Fallback: use base price from container
            variantPrice = parseInt(priceContainer.dataset.basePrice) || 0;
            variantComparePrice = parseInt(priceContainer.dataset.baseComparePrice) || variantPrice;
          }

          if (variantPrice > 0) {
            conjuntoTotalPrice += variantPrice;
            conjuntoTotalComparePrice += (variantComparePrice > variantPrice ? variantComparePrice : variantPrice);
          }
        }
      });
    }

    priceContainers.forEach(container => {
      const basePrice = parseInt(container.dataset.basePrice) || 0;
      const baseComparePrice = parseInt(container.dataset.baseComparePrice) || 0;

      // For conjunto products, use ONLY the conjunto prices (don't add base price)
      // For normal products, use base price
      const totalPrice = conjuntoSection ? conjuntoTotalPrice : basePrice;
      const totalComparePrice = conjuntoSection ? conjuntoTotalComparePrice : baseComparePrice;

      // Format price for display
      const formatPrice = (priceInCents) => {
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(priceInCents / 100);
      };

      // Update main price
      const priceElements = container.querySelectorAll('[data-total-price]');
      priceElements.forEach(el => {
        el.textContent = formatPrice(totalPrice);
      });

      // Update compare price
      const comparePriceElement = container.querySelector('[data-total-compare-price]');
      if (comparePriceElement) {
        if (totalComparePrice > totalPrice) {
          comparePriceElement.textContent = formatPrice(totalComparePrice);
          comparePriceElement.style.display = '';
        } else {
          comparePriceElement.style.display = 'none';
        }
      }

      // Update installments
      const installmentsContainer = container.querySelector('[data-installments]');
      if (installmentsContainer) {
        const installmentsDefault = parseFloat(container.dataset.installmentsDefault) || 5;
        const installmentsMinimum = parseFloat(container.dataset.installmentsMinimum) || 30;
        const priceInReais = totalPrice / 100;

        if (priceInReais >= installmentsMinimum) {
          const installmentAmount = totalPrice / installmentsDefault;
          const installmentElement = container.querySelector('[data-installment-amount]');
          if (installmentElement) {
            installmentElement.textContent = formatPrice(installmentAmount);
          }
          installmentsContainer.style.display = '';
        } else {
          installmentsContainer.style.display = 'none';
        }
      }

      // Update PIX price
      const pixContainer = container.querySelector('[data-pix-price]');
      if (pixContainer && totalPrice > 0) {
        const pixPercentage = parseFloat(container.dataset.pixPercentage) || 5;
        const pixDiscountAmount = totalPrice * pixPercentage / 100;
        const pixFinalPrice = totalPrice - pixDiscountAmount;
        const pixAmountElement = container.querySelector('[data-pix-amount]');
        if (pixAmountElement) {
          pixAmountElement.textContent = formatPrice(pixFinalPrice);
        }
        pixContainer.style.display = '';
      }
    });
  }

  const conjuntoSection = document.querySelector('[data-product-conjunto]');
  if (conjuntoSection) {
    // Handle conjunto product option changes
    conjuntoSection.addEventListener('click', function (e) {
      const optionButton = e.target.closest('.conjunto-option-value');
      if (optionButton && !optionButton.disabled) {
        const productItem = optionButton.closest('.conjunto-product-item');
        const variantId = optionButton.dataset.variantId;
        const variantPrice = optionButton.dataset.variantPrice;
        const variantImage = optionButton.dataset.variantImage;

        // Update selected state
        const optionGroup = optionButton.closest('.conjunto-option-group');
        optionGroup.querySelectorAll('.conjunto-option-value').forEach(btn => {
          btn.classList.remove('selected');
        });
        optionButton.classList.add('selected');

        // Update checkbox variant ID
        const checkbox = productItem.querySelector('.conjunto-product-checkbox-input');
        if (checkbox) {
          checkbox.dataset.variantId = variantId;
        }

        // Update price in conjunto item
        const priceContainer = productItem.querySelector('[data-conjunto-price]');
        const priceElement = productItem.querySelector('[data-conjunto-price] .current-price');
        if (priceElement && variantPrice && priceContainer) {
          const price = parseInt(variantPrice) / 100;
          priceElement.textContent = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }).format(price);

          // Update data attributes
          priceContainer.dataset.basePrice = variantPrice;

          // Try to get compare price from option button (if available)
          const comparePrice = optionButton.dataset.variantComparePrice ? parseInt(optionButton.dataset.variantComparePrice) : variantPrice;
          priceContainer.dataset.baseComparePrice = comparePrice;

          // Update compare price display
          const comparePriceElement = productItem.querySelector('[data-conjunto-price] .was-price');
          if (comparePrice && parseInt(comparePrice) > parseInt(variantPrice)) {
            if (!comparePriceElement) {
              const priceDiv = priceElement.parentElement;
              const wasPrice = document.createElement('span');
              wasPrice.className = 'was-price';
              priceDiv.insertBefore(wasPrice, priceElement);
            }
            const wasPriceEl = productItem.querySelector('[data-conjunto-price] .was-price');
            if (wasPriceEl) {
              wasPriceEl.textContent = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }).format(parseInt(comparePrice) / 100);
              wasPriceEl.style.display = '';
            }
          } else if (comparePriceElement) {
            comparePriceElement.style.display = 'none';
          }
        }

        // Update image
        const imageElement = productItem.querySelector('[data-conjunto-image]');
        if (imageElement && variantImage) {
          imageElement.src = variantImage;
        }

        // Update total prices
        // Short timeout to ensure dataset attributes are set
        setTimeout(updateTotalPrices, 50);

        // Also trigger buy button state update since a Conjunto change might complete the selection
        setTimeout(window.updateBuyButtonState, 100);
      }

      // Handle checkbox changes
      const checkbox = e.target.closest('.conjunto-product-checkbox-input');
      if (checkbox) {
        updateTotalPrices();
        // Also update buy button state since checkbox state affects validity
        setTimeout(window.updateBuyButtonState, 100);
      }
    });

    // Initial price calculation
    updateTotalPrices();
  }

  const productForms = document.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add"]');
  productForms.forEach(form => {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      const variantId = variantIdInput?.value;

      const conjuntoContainer = document.querySelector('[data-product-conjunto]');
      const items = [];

      if (conjuntoContainer) {
        const checkedBoxes = conjuntoContainer.querySelectorAll('.conjunto-product-checkbox-input:checked');
        checkedBoxes.forEach(checkbox => {
          if (checkbox.dataset.variantId) {
            items.push({
              id: checkbox.dataset.variantId,
              quantity: 1
            });
          }
        });
      } else {
        if (!variantId) return;
        items.push({
          id: variantId,
          quantity: parseInt(quantityInput.value) || 1
        });
      }

      if (items.length === 0) return;

      buyButton.classList.add('loading');
      buyButton.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });

        if (response.ok) {
          const productData = await response.json();
          const addedItems = productData.items ? productData.items : [productData];
          
          document.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { items: addedItems }
          }));

          document.dispatchEvent(new CustomEvent('updateCartDrawer'));
        } else {
          const errorData = await response.json();
          console.error('Error adding to cart', errorData);
        }
      } catch (error) {
      } finally {
        buyButton.classList.remove('loading');
        buyButton.disabled = false;
      }
    });
  });

  // Notify Me functionality - Handled by iStock app via classes in product-infos.liquid
  // We can add custom logic here if needed, but the app script adds its own listener to .iStock-notify-btn
  const notifySubmitButton = document.getElementById('notify-submit');
  if (notifySubmitButton) {
    // The iStock app script (iStock-notify-2.0.1.js) automatically adds a click listener
    // to elements with the .iStock-notify-btn class.
    // If we want to ensure it works even if the app loads after our script:
    notifySubmitButton.addEventListener('click', () => {
      if (window.iStock && typeof window.iStock.istockNotifyMe === 'function') {
        // The app's script might have already handled it, but this ensures a connection
        // Just in case it wasn't initialized yet or for dynamic content.
      }
    });
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  // Cronometer functionality - using the logic from cronometer.js
  function initCronometer() {

    // Get timer elements specifically within product-infos
    const productInfos = document.querySelector('.product-infos');
    if (!productInfos) {
      return;
    }

    const daysEl = productInfos.querySelector('#days');
    const hoursEl = productInfos.querySelector('#hours');
    const minutesEl = productInfos.querySelector('#minutes');
    const secondsEl = productInfos.querySelector('#seconds');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
      return; // Exit if elements aren't found
    }

    // Generate random time values - always create a new random time without persistence
    var randomHours = Math.floor(Math.random() * 5); // Random hours less than 5
    var randomMinutes = Math.floor(Math.random() * 60); // Random minutes less than 60
    var randomSeconds = Math.floor(Math.random() * 60); // Random seconds less than 60

    var endDate = new Date();
    endDate.setHours(endDate.getHours() + randomHours);
    endDate.setMinutes(endDate.getMinutes() + randomMinutes);
    endDate.setSeconds(endDate.getSeconds() + randomSeconds);

    // Convert to timestamp
    endDate = endDate.getTime();

    var timer = setInterval(function () {
      var now = new Date().getTime();
      var distance = endDate - now;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysEl.innerText = days.toString().padStart(2, '0');
      hoursEl.innerText = hours.toString().padStart(2, '0');
      minutesEl.innerText = minutes.toString().padStart(2, '0');
      secondsEl.innerText = seconds.toString().padStart(2, '0');

      if (distance < 0) {
        clearInterval(timer);
        // Instead of showing "EXPIRED", reinitialize with new random values
        initCronometer();
      }
    }, 1000);

    return timer;
  }

  // Initialize the countdown timer after DOM is fully loaded
  if (document.readyState === 'complete') {
    initCronometer();
  } else {
    window.addEventListener('load', initCronometer);
  }

  // Also initialize when the product counter becomes visible
  const productCounter = document.querySelector('.product-counter');
  if (productCounter) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          if (productCounter.style.display !== 'none') {
            initCronometer();
          }
        }
      });
    });

    observer.observe(productCounter, { attributes: true });
  }
});

// Make sure the initial button text is set correctly during pageload
document.addEventListener('DOMContentLoaded', function () {
  const buyButton = document.querySelector('.buy-button');
  if (buyButton && !buyButton.querySelector('.button-text')) {
    // If button text element doesn't exist, create it
    const buttonText = buyButton.textContent.trim();
    buyButton.textContent = '';

    const textSpan = document.createElement('span');
    textSpan.className = 'button-text';
    textSpan.textContent = buttonText;

    const spinnerSpan = document.createElement('span');
    spinnerSpan.className = 'spinner';

    buyButton.appendChild(textSpan);
    buyButton.appendChild(spinnerSpan);
  }
});

// Sticky Buy Bar visibility control
(function () {
  const stickyBar = document.getElementById('sticky-buy-bar');
  const buyButton = document.querySelector('.buy-button');


  if (!stickyBar || !buyButton) {
    return;
  }

  function hasPassedElement(el) {
    if (!el) {
      return false;
    }

    const rect = el.getBoundingClientRect();

    // Verificar se o elemento está acima da tela (usuário já passou dele)
    // rect.bottom < 0 significa que o elemento está completamente acima da tela
    const hasPassed = rect.bottom < 0;


    return hasPassed;
  }

  function onScroll() {
    // Debug info

    // No mobile, só mostrar o sticky bar depois de passar o botão de compra
    if (window.innerWidth <= 991) {
      // No mobile, usar o shipping-calc como referência (fica depois do botão de compra)
      const shippingCalc = document.getElementById('shipping-calc');
      const targetElement = shippingCalc || buyButton;


      if (hasPassedElement(targetElement)) {
        stickyBar.classList.remove('hidden');

        // Check and sync sticky bar when it becomes visible, but respect user selections
        setTimeout(() => {
          const hasValidSelections = checkForValidUserSelections();

          if (!hasValidSelections) {
            ensureStickySelectPlaceholders();
          } else {
          }
        }, 50);
      } else {
        stickyBar.classList.add('hidden');
      }
    } else {
      // No desktop, comportamento original (depois do botão)

      if (hasPassedElement(buyButton)) {
        stickyBar.classList.remove('hidden');

        // Check and sync sticky bar when it becomes visible, but respect user selections
        setTimeout(() => {
          const hasValidSelections = checkForValidUserSelections();

          if (!hasValidSelections) {
            ensureStickySelectPlaceholders();
          } else {
          }
        }, 50);
      } else {
        stickyBar.classList.add('hidden');
      }
    }
  }

  // Inicializa o estado correto ao carregar
  onScroll();
  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onScroll);

  // Test initial state
  setTimeout(() => {
    onScroll();
  }, 1000);
})();

// Sticky Buy Bar sync functionality
function initStickyBarSync() {
  const stickyBar = document.getElementById('sticky-buy-bar');
  if (!stickyBar) return;

  const mainVariantSelect = document.getElementById('variant-id');

  // Get both desktop and mobile sticky selects
  const stickyVariantSelects = stickyBar.querySelectorAll('.sticky-buy-bar__select-variant');
  const stickyButtons = stickyBar.querySelectorAll('.sticky-buy-bar__add-btn, .sticky-buy-bar__mobile-btn');


  // Sync main variant changes to all sticky bar selects
  if (mainVariantSelect && stickyVariantSelects.length > 0) {
    const syncVariantToSticky = () => {

      stickyVariantSelects.forEach(stickySelect => {
        // Only sync if this is a variant select
        if (stickySelect.name === 'id') {
          // Ensure placeholder always exists and has correct text
          const placeholderOption = stickySelect.querySelector('option[value=""]');
          if (placeholderOption) {
            placeholderOption.textContent = 'Selecionar';
          }
          // Check if user has actually made selections (not just programmatic)
          const productOptions = document.querySelectorAll('.product-options input[type="radio"]:checked');
          const buyButton = document.querySelector('.buy-button');
          const mainButtonText = buyButton ? buyButton.querySelector('.button-text') : null;

          // Only sync variant if user has made actual selections AND button shows "Adicionar ao carrinho"
          const hasUserSelections = productOptions.length > 0;
          const buttonShowsAddToCart = mainButtonText && mainButtonText.textContent.trim() === 'Adicionar ao carrinho';

          if (!hasUserSelections || !buttonShowsAddToCart) {
            // Force reset to placeholder if no user selections or button doesn't show "add to cart"
            stickySelect.value = '';
            stickySelect.style.color = '#666';
            if (placeholderOption) {
              placeholderOption.selected = true;
            }
          } else if (mainVariantSelect.value && mainVariantSelect.value !== '') {
            stickySelect.value = mainVariantSelect.value;
            stickySelect.style.color = '#222';
          }

        }
      });
      // Only check placeholders if no valid user selections exist
      setTimeout(() => {
        const hasValidSelections = checkForValidUserSelections();
        if (!hasValidSelections) {
          ensureStickySelectPlaceholders();
        }
      }, 10);
    };

    // Listen for changes in main variant using multiple methods
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          setTimeout(syncVariantToSticky, 50);
        }
      });
    });
    observer.observe(mainVariantSelect, { attributes: true, attributeFilter: ['value'] });

    // Also listen for input events
    mainVariantSelect.addEventListener('change', () => {
      setTimeout(syncVariantToSticky, 50);
    });

    // Listen for custom variant change events (for products with options)
    mainVariantSelect.addEventListener('variantChange', () => {
      setTimeout(syncVariantToSticky, 50);
    });

    // Watch for programmatic value changes
    let lastValue = mainVariantSelect.value;
    setInterval(() => {
      if (mainVariantSelect.value !== lastValue) {
        lastValue = mainVariantSelect.value;
        syncVariantToSticky();
      }
    }, 100);    // Force initial placeholder state only if no valid user selections exist
    setTimeout(() => {
      const hasValidSelections = checkForValidUserSelections();

      if (!hasValidSelections) {
        ensureStickySelectPlaceholders();
      } else {
      }
    }, 100);
  }
  // Sync sticky variant selects to main (handles normal variants)
  stickyVariantSelects.forEach(stickyVariantSelect => {
    if (stickyVariantSelect && mainVariantSelect) {
      stickyVariantSelect.addEventListener('change', () => {

        // Update text color based on selection
        if (stickyVariantSelect.value === '') {
          stickyVariantSelect.style.color = '#666';
        } else {
          stickyVariantSelect.style.color = '#222';
        }

        // Clear error state when user selects a valid option
        if (stickyVariantSelect.value && stickyVariantSelect.value !== '') {
          stickyVariantSelect.style.borderColor = '';
          stickyVariantSelect.style.borderWidth = '';
          stickyVariantSelect.style.boxShadow = '';
        }

        // Sync all other sticky selects to match this one
        stickyVariantSelects.forEach(otherSelect => {
          if (otherSelect !== stickyVariantSelect) {
            otherSelect.value = stickyVariantSelect.value;
            otherSelect.style.color = stickyVariantSelect.value === '' ? '#666' : '#222';
          }
        });

        // For normal variants, sync with main variant select AND radio buttons
        const oldValue = mainVariantSelect.value;
        mainVariantSelect.value = stickyVariantSelect.value;

        // Also try to sync with radio buttons if they exist
        if (stickyVariantSelect.value && stickyVariantSelect.value !== '') {
          // Find the variant by ID to get its options
          const selectedVariant = window.product.variants.find(variant => variant.id == stickyVariantSelect.value);
          if (selectedVariant) {
            // Sync radio buttons with variant options
            selectedVariant.options.forEach((optionValue, optionIndex) => {
              const optionName = window.product.options[optionIndex];

              // Find and check the corresponding radio button
              const radioButton = document.querySelector(`.product-options input[type="radio"][data-option-name="${optionName}"][value="${optionValue}"]`);
              if (radioButton) {
                radioButton.checked = true;
              }
            });
          }
        }

        // Trigger a custom event to notify the system about the change
        if (oldValue !== stickyVariantSelect.value) {
          mainVariantSelect.dispatchEvent(new Event('variantChange'));
          mainVariantSelect.dispatchEvent(new Event('change'));
        }

        // Always trigger update immediately - FORCE UPDATE
        if (window.updateBuyButtonState) {
          // Force immediate execution
          setTimeout(() => {
            window.updateBuyButtonState();

            // Double check - force button text update if variant is selected
            if (stickyVariantSelect.value && stickyVariantSelect.value !== '') {
              const buyButton = document.querySelector('.buy-button');
              const mainButtonText = buyButton ? buyButton.querySelector('.button-text') : null;

              if (mainButtonText) {
                mainButtonText.textContent = 'Adicionar ao carrinho';
                if (buyButton) {
                  buyButton.disabled = false;
                }

                // Force sync sticky buttons immediately
                const stickyButton = document.querySelector('.sticky-buy-bar__add-btn');
                const stickyMobileButton = document.querySelector('.sticky-buy-bar__mobile-btn');

                if (stickyButton) {
                  const stickyButtonTextFull = stickyButton.querySelector('.button-text-full');
                  const stickyButtonTextMobile = stickyButton.querySelector('.button-text-mobile');

                  if (stickyButtonTextFull && stickyButtonTextMobile) {
                    stickyButtonTextFull.textContent = 'Adicionar ao carrinho';
                    stickyButtonTextMobile.textContent = 'Adicionar';
                  }
                  stickyButton.disabled = false;
                }

                if (stickyMobileButton) {
                  const stickyMobileButtonText = stickyMobileButton.querySelector('span');
                  if (stickyMobileButtonText) {
                    stickyMobileButtonText.textContent = 'Adicionar';
                  }
                  stickyMobileButton.disabled = false;
                }
              }
            }
          }, 10);

          // Additional safety net
          setTimeout(() => {
            window.updateBuyButtonState();
          }, 100);

          // Force immediate sticky button text sync after variant change
          setTimeout(() => {
            // Direct update for safety
            const stickyButton = document.querySelector('.sticky-buy-bar__add-btn');
            const stickyMobileButton = document.querySelector('.sticky-buy-bar__mobile-btn');
            const buyButton = document.querySelector('.buy-button');

            if (buyButton) {
              const mainButtonText = buyButton.querySelector('.button-text');

              if (stickyButton && mainButtonText) {
                const stickyButtonTextFull = stickyButton.querySelector('.button-text-full');
                const stickyButtonTextMobile = stickyButton.querySelector('.button-text-mobile');

                if (stickyButtonTextFull && stickyButtonTextMobile) {
                  const mainText = mainButtonText.textContent.trim();

                  stickyButtonTextFull.textContent = mainText;
                  if (mainText === 'Adicionar ao carrinho') {
                    stickyButtonTextMobile.textContent = 'Adicionar';
                  } else if (mainText === 'Selecione o tamanho') {
                    stickyButtonTextMobile.textContent = 'Selecione';
                  } else if (mainText === 'Indisponível') {
                    stickyButtonTextMobile.textContent = 'Indisponível';
                  }
                }

                stickyButton.disabled = buyButton.disabled;
              }

              if (stickyMobileButton && mainButtonText) {
                const stickyMobileButtonText = stickyMobileButton.querySelector('span');

                if (stickyMobileButtonText) {
                  const mainText = mainButtonText.textContent.trim();

                  if (mainText === 'Adicionar ao carrinho') {
                    stickyMobileButtonText.textContent = 'Adicionar';
                  } else if (mainText === 'Selecione o tamanho') {
                    stickyMobileButtonText.textContent = 'Selecione';
                  } else if (mainText === 'Indisponível') {
                    stickyMobileButtonText.textContent = 'Indisponível';
                  }
                }

                stickyMobileButton.disabled = buyButton.disabled;
              }
            }
          }, 50);
        }
      });
    }
  });


  // Handle sticky bar form submissions (both desktop and mobile)
  const stickyForms = stickyBar.querySelectorAll('.sticky-buy-bar__form, .sticky-buy-bar__mobile-form');
  stickyForms.forEach(stickyForm => {
    const formButton = stickyForm.querySelector('.sticky-buy-bar__add-btn, .sticky-buy-bar__mobile-btn');
    if (formButton) {
      formButton.addEventListener('click', async (e) => {
        e.preventDefault();

        // Check if size is selected before proceeding
        const stickySelects = stickyForm.querySelectorAll('.sticky-buy-bar__select-variant');
        let hasValidSelection = false;

        stickySelects.forEach(select => {
          if (select.value && select.value !== '') {
            hasValidSelection = true;
            // Remove red border if it was there
            select.style.borderColor = '';
            select.style.borderWidth = '';
            select.style.boxShadow = '';
          } else {
            // Add red border to indicate error
            select.style.borderColor = '#ff0000';
            select.style.borderWidth = '2px';
            select.style.boxShadow = '0 0 5px rgba(255, 0, 0, 0.3)';
          }
        });

        if (!hasValidSelection) {
          // Don't proceed with add to cart
          return;
        }

        // Use the main buy button logic
        const mainBuyButton = document.querySelector('.buy-button');
        if (mainBuyButton) {
          mainBuyButton.click();
        }
      });
    }
  });
}

// Function to update sticky bar icon specifically
function updateStickyButtonIcon(show) {
  const stickyButtons = document.querySelectorAll('.sticky-buy-bar__add-btn, .sticky-buy-bar__mobile-btn');
  stickyButtons.forEach(stickyButton => {
    if (stickyButton) {
      const stickyIcon = stickyButton.querySelector('svg');
      if (stickyIcon) {
        stickyIcon.style.display = show ? 'inline-block' : 'none';
      }
    }
  });
}

// Function to check if user has made valid selections
function checkForValidUserSelections() {
  const productOptions = document.querySelectorAll('.product-options input[type="radio"]:checked');
  const buyButton = document.querySelector('.buy-button');
  const mainButtonText = buyButton ? buyButton.querySelector('.button-text') : null;

  const hasUserSelections = productOptions.length > 0;
  const buttonShowsAddToCart = mainButtonText && mainButtonText.textContent.trim() === 'Adicionar ao carrinho';

  // User has valid selections if they made choices AND button shows "add to cart"
  return hasUserSelections && buttonShowsAddToCart;
}

// Function to ensure sticky bar select placeholders are visible
function ensureStickySelectPlaceholders() {
  const stickySelects = document.querySelectorAll('.sticky-buy-bar__select-variant');

  stickySelects.forEach((select, index) => {
    // Always ensure placeholder is first and has correct text
    const placeholderOption = select.querySelector('option[value=""]');
    if (placeholderOption) {
      placeholderOption.textContent = 'Selecionar';

      const hasValidSelections = checkForValidUserSelections();


      if (!hasValidSelections) {
        // Force reset to placeholder if no valid selections
        placeholderOption.selected = true;
        select.value = '';
        select.style.color = '#666'; // Ensure placeholder color
      } else {
        select.style.color = '#222'; // Normal text color when option selected
      }
    }
  });
}

// Function to initialize placeholder only when appropriate
function initializePlaceholdersIfNeeded() {
  const hasValidSelections = checkForValidUserSelections();

  if (!hasValidSelections) {
    const stickySelects = document.querySelectorAll('.sticky-buy-bar__select-variant');

    stickySelects.forEach((select, index) => {
      const placeholderOption = select.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.selected = true;
        placeholderOption.textContent = 'Selecionar';
        select.value = '';
        select.style.color = '#666';
        select.selectedIndex = 0;

      }
    });
  } else {
  }
}

// Function to check if mobile sticky bar has selects and adjust layout
function checkMobileStickySelectLayout() {
  const stickyBar = document.getElementById('sticky-buy-bar');
  if (!stickyBar) return;

  const mobileTop = stickyBar.querySelector('.sticky-buy-bar__mobile-top');
  const mobileSelect = stickyBar.querySelector('.sticky-buy-bar__mobile-select');
  const selectElement = mobileSelect ? mobileSelect.querySelector('select') : null;


  if (mobileTop) {
    // Check if there's a visible select element with actual options
    const hasVisibleSelect = selectElement &&
      selectElement.style.display !== 'none' &&
      selectElement.options.length > 1 && // More than just placeholder
      !selectElement.disabled;

    if (hasVisibleSelect) {
      mobileTop.classList.remove('no-select');
    } else {
      mobileTop.classList.add('no-select');
    }
  }
}

// Initialize sticky buy bar synchronization after DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  // Wait a bit for the sticky bar to be rendered
  setTimeout(() => {
    initStickyBarSync();

    // Check mobile sticky layout after initializationa
    checkMobileStickySelectLayout();

    // Initialize placeholders only if no valid user selections exist
    setTimeout(() => {
      const hasValidSelections = checkForValidUserSelections();

      if (!hasValidSelections) {
        const stickySelects = document.querySelectorAll('.sticky-buy-bar__select-variant');
        stickySelects.forEach((select, index) => {
          const placeholderOption = select.querySelector('option[value=""]');
          if (placeholderOption) {
            placeholderOption.selected = true;
            placeholderOption.textContent = 'Selecionar';
            select.value = '';
            select.style.color = '#666';
          }
        });
      } else {
      }
      // Re-check mobile layout after any changes
      checkMobileStickySelectLayout();
    }, 100);
  }, 100);
});

// Function to copy coupon code
window.copyCouponCode = function(button) {
  const couponCode = button.getAttribute('data-coupon');
  const successText = button.getAttribute('data-success-text') || 'CUPOM COPIADO';
  
  if (!couponCode) return;

  // Save original content
  const originalContent = button.innerHTML;

  // Copy to clipboard
  navigator.clipboard.writeText(couponCode).then(function() {
    button.innerHTML = successText;
    setTimeout(() => {
      button.innerHTML = originalContent;
    }, 2000);
  }).catch(function(err) {
    console.error('Error copying coupon:', err);
    // Basic fallback
    const textArea = document.createElement('textarea');
    textArea.value = couponCode;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    
    button.innerHTML = successText;
    setTimeout(() => {
      button.innerHTML = originalContent;
    }, 2000);
  });
};

// Initialize coupon listeners
document.addEventListener('DOMContentLoaded', () => {
  // Attach listeners to coupon buttons that might not have inline onclick
  document.querySelectorAll('[data-coupon]').forEach(btn => {
    if (!btn.hasAttribute('onclick')) {
      btn.addEventListener('click', () => window.copyCouponCode(btn));
    }
  });
});